import { useAuthStore } from "./auth.js";
import { useThemeStore } from "./theme.js";
import { useDepartmentStore } from "./department.js";
import { useOrganizationStore } from "./organization.js";
import { useTeamStore } from "./team.js";
import { useUnitStore } from "./unit.js";
import { useUserStore } from "./user.js";
import { useCountsStore } from "./counts.js";
import { useCustomAuthRoleGroupsStore } from "./role.js";
import { useAdminStore } from "./admin.js";
import { useMessengerStore } from "./messenger.js";
import { useWebSearchTopicStore } from "./web_search_topic.js";
import { useWfbChatStore } from "./wfbChat.js";
import { useAnnouncementStore } from "./announcements.js";
import { useAnalyticsStore } from "./analytics.js";

export default {
  useAnnouncementStore,
  useAuthStore,
  useThemeStore,
  useDepartmentStore,
  useOrganizationStore,
  useTeamStore,
  useUnitStore,
  useUserStore,
  useCountsStore,
  useCustomAuthRoleGroupsStore,
  useAdminStore,
  useMessengerStore,
  useWebSearchTopicStore,
  useWfbChatStore,
  useAnalyticsStore,
};
